import {
	Container,
	ReferenceBadge,
	Text,
	TextAlignment,
	ThemeProvider,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../../../../../helpers/color-tokens';

const StyledC2Wrapper = styled.div`
	border-top: 2px solid ${COLOR_TOKEN.content.inverted};
	border-bottom: 2px solid ${COLOR_TOKEN.content.inverted};
	align-content: center;
	padding: var(--size-dynamic0100) 4px;
`;

const StyledAmountText = styled.div`
	display: flex;
	align-items: end;

	& * {
		line-height: 100%;
		font-family: var(--font-family-head);
		font-weight: 100;
	}

	& [data-testid='hucha-amount'] {
		font-size: clamp(90px, 4.6rem + 5vw, 112px);

		@media (min-width: 1230px) {
			font-size: clamp(90px, 3.6rem + 3vw, 112px);
		}
	}
	& [data-testid='hucha-currency'] {
		font-size: clamp(60px, 2rem + 2.5vw, 90px);
	}
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 20px;
`;

export const PdfBonoPosventaCardC2 = ({ dineroHucha }: { dineroHucha: string }) => {
	const badge = '1';
	return (
		<Container stretchContent data-testid="pdf-c2-container">
			<StyledC2Wrapper>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.primary}
					textAlign={TextAlignment.center}
					bold
				>
					Para tu próxima visita
				</Text>
				<Container wrap="never" horizontalAlign="center">
					<Container wrap="never" verticalAlign="flex-end">
						<StyledAmountText>
							<Text data-testid="hucha-amount" color={TokenTextColor.primary}>
								{dineroHucha}
							</Text>
							<Text data-testid="hucha-currency" color={TokenTextColor.primary}>
								{'€'}
							</Text>
						</StyledAmountText>
					</Container>
					<ThemeProvider theme={'main'}>
						<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
					</ThemeProvider>
				</Container>
			</StyledC2Wrapper>
		</Container>
	);
};
